import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NgxGoBannerComponent } from './go-banner.component';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule
	],
	declarations: [
		NgxGoBannerComponent
	],
	exports: [
		NgxGoBannerComponent
	]
})
export class GoBannerModule {}
